import {getStorage, setStorage, removeStorage} from "helpers/storage";

/**
 * The BankID same-device flow leaves the browser for the BankID app and comes back
 * through the "redirect" url, which is a full page load: all react state is lost and
 * the started order would never be collected. The pending order is kept in the storage
 * so the authentication can be resumed after returning from the app.
 */
const pendingBankIdAuthKey = (contractId) => `hs_bankid_pending_${contractId}`;
// an order started in the BankID app stays collectable for about 3 minutes
const pendingBankIdAuthLifetime = 5 * 60 * 1000;

export const setPendingBankIdAuth = (contractId, data) =>
  setStorage(
    pendingBankIdAuthKey(contractId),
    JSON.stringify({...data, savedAt: Date.now()})
  );

export const removePendingBankIdAuth = (contractId) =>
  removeStorage(pendingBankIdAuthKey(contractId));

export const getPendingBankIdAuth = (contractId) => {
  try {
    const pending = JSON.parse(getStorage(pendingBankIdAuthKey(contractId)));
    if (!pending?.orderRef || !pending?.participantId) return null;
    if (Date.now() - (pending.savedAt ?? 0) > pendingBankIdAuthLifetime) {
      removePendingBankIdAuth(contractId);
      return null;
    }
    return pending;
  } catch (_e) {
    return null;
  }
};
